import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_SPONSORSHIP_REJECT)
  },
  method: 'POST',
  format(payload) {
    return {
      id: payload?.id,
      reason: payload?.reason
    }
  },
  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to reject sponsorship',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Sponsorisation rejetée',
      data: raw.data,
    }
  },
}
